function ProductRequestForService(state = { ProductReques: '',UsersList:[],UsedPartList:[], purchaseProductList:[] }, action) {
  
    switch (action.type) {
      
      case "FETCH_Product_Request":
        return {
          ...state,
          ProductReques: action.data
        };
              case "FETCH_User_List":
        return {
          ...state,
          UsersList: action.data
        };
        case "Set_Local_Part_List":
          return {
            ...state,
            UsedPartList: action.data
          };
          case "SEARCH_PURCHACE_PRODUCTS":
            return {
              ...state,
              purchaseProductList: action.data
            };          
      default:
        return state;
    }
  }
  
  export default ProductRequestForService;